import { Update } from 'history';
import { languageRouting } from './language';
import { sectionsRouting } from './sections';

export const routing = (currentUpdate: Update) => {
  languageRouting(currentUpdate);
  sectionsRouting(currentUpdate);
};
